import React, { Fragment } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Label, FormGroup, Input } from "reactstrap"
import { DefaultColumnFilter } from "components/Common/filters"
import { useEffect } from "react"
import { useState } from "react"
import JobListGlobalFilter from "components/Common/GlobalSearchFilter"
import { GetObjByAttendanceUserRoles } from "_mock/Static_data"

// Define a default UI for filtering
function GlobalFilter({
  globalFilter,
  setGlobalFilter,
  isJobListGlobalFilter,
  filterData,
}) {
  const [value, setValue] = React.useState(globalFilter)
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
  }, 200)

  return (
    <React.Fragment>
      <Col md={12}>
        <div className="search-box w-full d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value),
                    onChange(e.target.value)
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={"Search…"}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </Col>
      {isJobListGlobalFilter && <JobListGlobalFilter />}
    </React.Fragment>
  )
}

const AttendanceUserTable = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddUserList,
  handleUserClick,
  className,
  filterData,
  pagePerSize,
  isLoading,
  TotalRecords,
  writeDataToExcel,
  filterRoleId,
  setfilterRoleId,
  setIsActive,
  isActive
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setPageSize,
    state,
    setGlobalFilter,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageSize: 20,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useExpanded,
    usePagination
  )
  const handlesort = column => { }
  const [pageIndex, setpageIndex] = useState(1)


  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? "🔽" : "🔼") : ""
  }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
  }

  const [isMobile, setisMobile] = useState(window.innerWidth < 924)

  useEffect(() => {
    pagePerSize(pageSize, pageIndex)
  }, [pageSize, pageIndex])

  useEffect(() => {
    setpageIndex(1);
  }, [pageSize]);

  return (
    <Fragment>
      <div className="row">
        <div className="col-md-8 mb-sm-2">
          <div className="row">
            <div className={`${isMobile ? `col-md-3` : `col-md-2`} mb-2`}>
              <select
                className="form-select"
                value={pageSize}
                onChange={onChangeInSelect}
              >
                {[10, 20, 30, 40, 50].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </div>
            <div className={`${isMobile ? `col-md-4` : `col-md-3`} mb-sm-2 mb-md-0`}>
              {isGlobalFilter && (
                <GlobalFilter
                  globalFilter={state.globalFilter}
                  setGlobalFilter={setGlobalFilter}
                  isJobListGlobalFilter={isJobListGlobalFilter}
                />
              )}
            </div>
            <div className={`${isMobile ? `col-md-5` : `col-md-4`} mb-sm-2 mb-md-0`}>
              <FormGroup>
                <Input
                  type="select"
                  id="validationCustom01"
                  className="form-control"
                  name="taskType"
                  onChange={e => {
                    setfilterRoleId(e.target.value)
                  }}
                  value={filterRoleId}
                >
                  <option value={0}>Select User Role</option>
                  {GetObjByAttendanceUserRoles(1, 2, 3, 4).map((item, index) => {
                    return (
                      <option key={index} value={item.Value}>
                        {item.Key}
                      </option>
                    )
                  })}
                </Input>
              </FormGroup>
            </div>
            <div className={`${isMobile ? `col-md-4` : `col-md-3`} mb-sm-2 mb-md-0`}>
              <div className={`mb-sm-2 mb-md-0 mt-2`}>
                <FormGroup check>
                  <Input
                    id="checkbox3"
                    type="checkbox"
                    defaultChecked={isActive}
                    onChange={e => setIsActive(e.target.checked)}
                  />
                  <Label for="checkbox3" check>
                    Inactive Users
                  </Label>
                </FormGroup>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="text-sm-end justify-content-end d-flex gap-3">
            <div>
              {data.length > 0 ? (<button
                type="button"
                className="btn btn-excel  btn-label"
                onClick={writeDataToExcel}
              >
                Excel <i className="far fa-file-excel label-icon"></i>
              </button>) : (<button
                type="button"
                className="btn  btn-excel  btn-label"
                style={{ cursor: "not-allowed" }}
              >
                Excel <i className="far fa-file-excel label-icon"></i>
              </button>)}
            </div>
            <Button
              type="button"
              color="primary"
              className="btn  mb-2 "
              onClick={handleUserClick}
            >
              <i className="mdi mdi-plus-circle-outline me-1" />
              Create
            </Button>
          </div>
        </div>
      </div>


      <div className="table-responsive react-table">
        <Table bordered  {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    onClick={() => {
                      handlesort(column)
                    }}
                    {...column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                        width: column.width,
                      },
                    })}
                  >
                    <div className={`mb-0`}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {page.length ? (
            <tbody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr>
                      {row.cells.map(cell => {
                        return (
                          <td
                            key={cell.id}
                            className={`text-nowrap`}
                            {...cell.getCellProps({
                              style: {
                                minWidth: cell.minWidth,
                                maxWidth: cell.maxWidth,
                                width: cell.width,
                              },
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })}
            </tbody>
          ) : (
            <tbody
              style={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                height: "40px",
              }}
            >
              <tr>
                <td colSpan={headerGroups[0].headers.length}>
                  {isLoading ? "Loading..." : "No Record Found"}
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex - 1)}
              disabled={pageIndex == 1}
            >
              {"<<"}
            </Button>
            {/* <Button
              color="primary"
              onClick={previousPage}
              // disabled={!canPreviousPage}
            >
              {"<"}
            </Button> */}
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page
          <strong style={{ marginLeft: "5px" }}>
            {TotalRecords == 0 ? 1 : pageIndex} of {TotalRecords == 0 ? 0 : Math.ceil(TotalRecords / pageSize)}
          </strong> | Total <strong>{TotalRecords}</strong>
        </Col>
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            {/* <Button color="primary" onClick={nextPage} disabled={!canNextPage}> */}
            {/* <Button color="primary" onClick={pageIndex}>
              {">"}
            </Button> */}
            <Button
              color="primary"
              onClick={() => setpageIndex(pageIndex + 1)}
              disabled={pageIndex == (pageIndex == 1 && TotalRecords == 0 ? Math.ceil(TotalRecords / pageSize) + 1 : Math.ceil(TotalRecords / pageSize))}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  )
}

AttendanceUserTable.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default AttendanceUserTable
